import { render } from "./Shop.vue?vue&type=template&id=2fdbf878"
import script from "./Shop.vue?vue&type=script&lang=js"
export * from "./Shop.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__